import { render, staticRenderFns } from "./createBucket.vue?vue&type=template&id=132574c1&scoped=true"
import script from "./createBucket.vue?vue&type=script&lang=js"
export * from "./createBucket.vue?vue&type=script&lang=js"
import style0 from "./createBucket.vue?vue&type=style&index=0&id=132574c1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "132574c1",
  null
  
)

export default component.exports